import React from "react";
import { useAppContent } from "./AppContent.hook";
import { DeveloperWorkbench } from "../DeveloperWorkbench/DeveloperWorkbench";
import { Sidebar } from "../Layout/Sidebar";
import { TopBar } from "../Layout/TopBar";
import { Footer } from "../Layout/Footer";
import { AppRoutes } from "./AppRoutes/AppRoutes";
import { mercury } from "@bfme-technology/styled";
import { ToastContainer } from "../Toast/ToastContainer";

export const AppContent: React.FC = () => {
  const {
    isSidebarOpen,
    setIsSidebarOpen,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    isDevWorkbenchOpen,
    setIsDevWorkbenchOpen,
    activeTab,
    isCounterInjected,
    setIsCounterInjected,
    reduxStateStr,
    routes,
    routesLoading,
    theme,
    toggleTheme,
    userEmail,
    userName,
    userInitials,
    userData,
    changeLanguage,
    handleLogout,
    handleSettingsClick,
    currentLanguage
  } = useAppContent();

  return (
    <div className={`host-shell-layout ${mercury.layoutWrapperClass}`}>
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        isSidebarCollapsed={isSidebarCollapsed}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
      />

      <div className={`host-main-layout ${mercury.layoutMainClass}`}>
        <TopBar
          activeTab={activeTab}
          theme={theme}
          toggleTheme={toggleTheme}
          isDevWorkbenchOpen={isDevWorkbenchOpen}
          setIsDevWorkbenchOpen={setIsDevWorkbenchOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          userName={userName}
          userEmail={userEmail}
          userInitials={userInitials}
          onLogout={handleLogout}
          onSettingsClick={handleSettingsClick}
        />

        <main className={`host-content-layout ${mercury.contentAreaClass}`}>
          <AppRoutes
            routesLoading={routesLoading}
            routes={routes}
            isCounterInjected={isCounterInjected}
            setIsCounterInjected={setIsCounterInjected}
            reduxStateStr={reduxStateStr}
            userName={userName}
            userEmail={userEmail}
            userData={userData}
          />
          <Footer
            changeLanguage={changeLanguage}
            currentLanguage={currentLanguage}
          />
        </main>
      </div>

      <DeveloperWorkbench
        isOpen={isDevWorkbenchOpen}
        setIsOpen={setIsDevWorkbenchOpen}
      />
      <ToastContainer />
    </div>
  );
};

export default AppContent;
